import React from 'react';
import { PageError } from '../../../components/page';
import { RouteParams, useParams } from '../../../routes';
import { useTitle } from '../../../utils/useTitle';
import { SurveyInterstitialContent } from './components/SurveyInterstitialContent';
import { SurveyPageWrapper } from './components/SurveyPageWrapper';
import { useSurveyNavigation } from './hooks/useSurveyNavigation';
import { useSurveyRedirect } from './hooks/useSurveyRedirect';
import { validateInterstitialRoute } from './utils/validators';

type SurveyPrescreenPageParams = RouteParams<'surveyInterstitials'>;

export const SurveyInterstitialPage = (): JSX.Element => {
  useTitle(['Student Survey']);
  useSurveyRedirect();
  const { interstitialRoute } = useParams<SurveyPrescreenPageParams>();
  const navigation = useSurveyNavigation();

  const validInterstitialRoute = validateInterstitialRoute(interstitialRoute);

  if (validInterstitialRoute === null) {
    return <PageError />;
  }

  const onContinue = (): void => {
    navigation.goToNext();
  };

  return (
    <SurveyPageWrapper
      title="Student Survey"
      testID={`survey-interstitial-page-${validInterstitialRoute}`}
    >
      <SurveyInterstitialContent
        interstitialRoute={validInterstitialRoute}
        onContinue={onContinue}
      />
    </SurveyPageWrapper>
  );
};
